<template>
  <div>
    <!-- <meta name="viewport" content="width=device-width,initial-scale=1.0" /> -->
    <sub-head subTitle="제품 소개" subImg="product_top" class="web"></sub-head>
    <div class="page_padding">
      <bread-crumb :path="$route" class="bread"></bread-crumb>
    </div>

    <div class="main-page">
      <div v-if="summary" class="summary" style="padding-top: 90px">
        <h2 v-html="summary.h"></h2>
        <p style="margin-top: 40px" v-html="summary.p"></p>
        <image-component
          style="padding-top: 90px; padding-top: 100px;"
          path="product32/table32_01.png"
        ></image-component>
      </div>

      <div v-if="solution" class="solution-program" style="padding-top: 162px">
        <h1 v-html="solution.h"></h1>
        <p style="margin-top: 40px" v-html="solution.p"></p>
        <div v-if="solutionList" class="flex" style="margin-top: 80px;">
          <div
            v-for="(obj, index) in solutionList"
            :key="index + obj.title"
            style="max-width: 570px;"
          >
            <image-component :path="obj.imgPath"></image-component>
            <h4 style="margin-top: 30px; text-align: left;">{{ obj.title }}</h4>
            <p style="margin-top: 20px; text-align: left;">
              {{ obj.content }}
            </p>
          </div>
        </div>
        <div style="padding-top: 187px;"></div>
      </div>

      <!-- <div v-if="collection" class="data-collection" style="margin-top: 160px">
        <h1 v-html="collection.h"></h1>
        <p
          style="margin-top: 62px; text-align: left;"
          v-html="collection.p"
        ></p>
        <div v-if="dataCollectionList" class="flex" style="margin-top: 110px">
          <div
            v-for="(obj, index) in dataCollectionList"
            :key="index + obj.title"
            style="width: 320px"
          >
            <image-component
              class="circle-bg"
              :path="obj.imgPath"
            ></image-component>
            <h4 style="margin-top: 30px">{{ obj.title }}</h4>
            <p style="margin-top: 20px; max-width: 300px;">{{ obj.content }}</p>
          </div>
        </div>
        <hr style="margin-top: 100px;" />
      </div> -->

      <div v-if="scenario" class="scenario" style="padding-top: 162px">
        <h1 v-html="scenario.h[0]"></h1>
        <h2 style="margin-top: 62px;" v-html="scenario.h[1]"></h2>
        <p style="margin-top: 40px;" v-html="scenario.p"></p>
        <image-component
          style="margin-top: 85px; margin-bottom: 205px;"
          path="product32/product32_scenario@2x.png"
        />
      </div>

      <!-- same as solution section -->
      <div v-if="feature" class="feature" style="padding-top: 121px">
        <h1 v-html="feature.h"></h1>
        <p style="margin-top: 40px" v-html="feature.p"></p>
        <div style="margin-top: 80px;"></div>
        <div v-if="featureList" class="flex">
          <div v-for="(obj, index) in featureList" :key="index + obj.title">
            <image-component :path="obj.imgPath"></image-component>
            <h4
              style="margin: 30px 7px; text-align: left;"
              v-html="obj.title"
            ></h4>
            <p style="margin-top: 20px; max-width: 570px; text-align: left;">
              {{ obj.content }}
            </p>
          </div>
        </div>
        <div style="padding-top: 187px;"></div>
      </div>
      <!-- need to optimize divider -->
      <div class="divider" style="background: none;"><hr /></div>
      <div v-if="spec" class="spec" style="margin-top: 155px;">
        <h1 v-html="spec.h"></h1>
        <h5 v-html="spec.p"></h5>
        <div class="flex" style="margin-top: 163px">
          <image-component
            path="product32/table32_02.png"
            style="flex-grow: 2;"
          ></image-component>
          <table v-if="specList" style="margin: auto;">
            <tr v-for="(value, key) in specList" :key="key + value">
              <th>{{ key }}</th>
              <td>{{ value }}</td>
            </tr>
          </table>
        </div>
        <div style="padding-top: 210px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from "@/components/imageComponent.vue";
import subHead from "@/components/sub_head.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";

// import Tab from "@/components/Tab.vue";
export default {
  components: {subHead, ImageComponent, BreadCrumb},

  data() {
    return {
      summary: {
        h:
          '시니어 여가활동 증진 및 인지능력 향상 목적인<br />기능성 게임이 탑재된 <b>"스마트 터치 테이블"</b>',
        p:
          "사용자 데이터 기반으로 경도인지 장애를 선별하고, 지속적인 추적관리가 가능한 시스템",
      },
      solution: {
        h: "해피테이블 솔루션 프로그램",
        p: "최고의 인지능력 향상 프로그램으로 치매 예방에도 기여합니다.",
      },
      solutionList: [
        {
          title: "다양한 인지향상 기능성 게임",
          content: `최대4인이 함께하는 지남력,기억력,수리력,언어력,순발력 등\n인지 8대 요소를 향상시키는 경쟁,협동,힐링,학습 기능성 게임`,
          imgPath: "product32/product32_img01.png",
        },
        {
          title: "USB를 통한 영상 시청",
          content:
            "체조 따라 하기, 노래 따라 부르기, 힐링 영상 시청 등\nUSB에 원하는 영상을 넣어 재생 가능",
          imgPath: "product32/product32_img02.png",
        },
        {
          title: "CMS 통합 관리 사이트 제공",
          content:
            "회원별 상세데이터, 게임별 상세 데이터, 날짜별 상세 데이터 제공",
          imgPath: "product32/product32_img03.png",
        },
        {
          title: "그 외 다양한 콘텐츠",
          content:
            "치매 예방 체조, 레크레이션, 간이정신상태 검사 등 콘텐츠 탑재\n다양한 콘텐츠를 지속적으로 업데이트",
          imgPath: "product32/product32_img04.png",
        },
      ],
      scenario: {
        h: [
          "해피테이블 시나리오",
          "해피 테이블을 통해 진행하는 <b>'모든 인지 활동 프로그램에 대한 데이터'</b>를 수집합니다.",
        ],
        p:
          "이러한 데이터는 해피 테이블만의 알고리즘을 통하여 반응력, 기억력, 문제 해결력, 주의력, 유연성, 수리력에 대한\n\
          인지 기능 측정 및 치매에 관련한 위험도를 분석하고 경고합니다.",
      },
      scenarioList: [
        {
          title: "인지평가 게임",
          content: "개인별 인지상태를 평가",
          imgPath: "product32/ic_brain.png",
        },
        {
          title: "CMS 통합 관리 사이트",
          content: "개인별 인지 솔루션 데이터 제공",
          imgPath: "product32/ic_cms.png",
        },
        {
          title: "해피테이블 기능성 게임",
          content: "인지 솔루션을 바탕으로 해피테이블 기능성 게임 진행",
          imgPath: "product32/ic_game.png",
        },
        {
          title: "인지평가 게임",
          content: "개인별 인지상태를 재평가",
          imgPath: "product32/ic_brain.png",
        },
      ],
      feature: {
        h: "해피테이블 특징",
      },
      featureList: [
        {
          title:
            "다인<span style='font-family: sans-serif'>(多人)</span>참여형 테이블",
          content:
            "게임에 적합하고 4인 동시 플레이가 가능한 스마트테이블\n노인의 체형 및 안전을 고려한 테이블 디자인",
          imgPath: "product32/product32_img05.png",
        },
        {
          title: "노인전용 게임 콘텐츠",
          content:
            "노인층에 맞는 실버 인터페이스 및 GUI, 디자인 요소\n심리적 안정과 두뇌활동에 도움을 주는 기능성 게임 콘텐츠",
          imgPath: "product32/product32_img06.png",
        },
        {
          title: "원격 업데이트",
          content:
            "지속적으로 업데이트되는 다양한 콘텐츠\n업데이트 사항이 있을 시, 최초 전원을 키게 되면 업데이트 항목이 팝업 화면에 표시됩니다",
          imgPath: "product32/product32_img07.png",
        },
        {
          title: "통합 관리 솔루션",
          content:
            "콘텐츠 데이터 결과/분석 CMS 확인\n사용자 데이터 취합/분석 결과 CMS 확인",
          imgPath: "product32/product32_img08.png",
        },
      ],
      spec: {
        h: "32인치 표준형 해피테이블",
        p: "(happytable 32inch standard type)",
      },
      specList: {
        제품명: "해피테이블 32인치 표준형",
        모델명: "HT32SS",
        "제품 규격": "1055(W)x748(D)x725(H) mm",
        중량: "-",
        "전원 및 소비전력": "220V / 76W",
        멀티터치: "20포인트",
        스피커출력: "8W",
        "상판 유리두께": "4T",
        운영체제: "안드로이드",
      },
    };
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  word-break: keep-all;
  word-wrap: break-word;
}
h1 {
  font-size: 2.5rem;
  font-weight: 800;
  line-height: 3.75rem;
  color: #0a0a0a;
}

h2 {
  font-size: 2.125rem;
  font-weight: bold;
  line-height: 3.75rem;
  letter-spacing: -0.064rem;
  color: #878282;
}

h4 {
  font-size: 1.375rem;
  line-height: 1.688rem;
  font-weight: 800;
  color: #1c1c1c;
}

h5 {
  font-size: 1.25rem;
  line-height: 2.75rem;
  font-weight: 800;
  color: #1c1c1c;
}

.main-page ::v-deep b {
  color: #ff5230;
}

p {
  font-size: 1.125rem;
  font-weight: 500;
  color: #5a5a5a;
  line-height: 2.375rem;
  word-break: keep-all;
  word-wrap: break-word;
  white-space: pre-line;
}

hr {
  border: 1px solid #0a0a0a;
}

table {
  border-collapse: collapse;
}

th,
td {
  border-top: 1px solid #707070;
  border-bottom: 1px solid #707070;
  padding: 18px 20px;
}

td {
  color: #5a5a5a;
  text-align: left;
}

th {
  background-color: #f6f6f6;
  color: #1c1c1c;
}

/* TODO: because of mulfunction of image width v-deep is used, need to fix. */
::v-deep img {
  width: unset !important;
  max-width: 100%;
}

.main-page > div > * {
  max-width: 1200px;
  margin: auto;
  padding: 0 20px;
}

.main-page > div:nth-child(even) {
  background-color: #f7f9fb;
}

/* .main-page > div:nth-child(odd) {} */

.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 60px 30px;
}

.flex > * {
  flex: 1 1 auto;
  margin: 0 auto;
}

.flex p {
  font-size: 0.875rem;
  line-height: 1.5rem;
  margin: auto;
}

.spec {
  background: none !important;
}

.circle-bg {
  background: #f6f6f6;
  border-radius: 50%;
  width: 180px;
  height: 180px;
  margin: auto;
  padding: 39px;
  box-sizing: border-box;
}

.scenario-item {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: 234px;
  height: 334px;

  border: 2px solid #e4e4e4;
  padding-top: 57px;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .banner.web {
    margin-top: 60px;
    .banner-title {
      font-size: 1.5rem;
    }
  }

  h1 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  h2 {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
}
</style>
